import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';
import { UpcomingAppointmentFragment } from '@/graphql/types-and-hooks';

type State = {
  appointment: UpcomingAppointmentFragment | null; // Make it nullable
};

type Actions = {
  setAppointment: (appointment: UpcomingAppointmentFragment) => void;
  resetAppointment: () => void;
};

const initialState: State = {
  appointment: null, // Set initial value as null
};

const useUpcomingAppointmentStoreBase = createWithEqualityFn<State & Actions>()(set => ({
  ...initialState,
  setAppointment: appointment => set({ appointment }),
  resetAppointment: () => set(initialState),
}));

export const useUpcomingAppointmentStore = <U>(
  selector: (state: State & Actions) => U
) => {
  return useUpcomingAppointmentStoreBase(selector, shallow);
};
